import React from 'react'

import { useCartRedux } from '@hooks'
import CartEmpty from './CartEmpty'
import CartList from './CartList'

const CartContent = () => {
    const { items } = useCartRedux()

    if (items.length === 0) return <CartEmpty />

    return <CartList />
}

export default CartContent
